export const EtowerTableColumns = [
  { label: 'Id', field: 'Id' },
  { label: 'Date', field: 'Datetime' },
  { label: 'Order ID', field: 'OrderId' },
  { label: 'ReferenceNo', field: 'ReferenceNo' },
  { label: 'TrackingNo', field: 'TrackingNo' },
  { label: 'State', field: 'State' },
  { label: 'Post Code', field: 'Postcode' },
  { label: 'Status' },
  { label: 'Link' },
];
